import { render, staticRenderFns } from "./MallItem.vue?vue&type=template&id=d87052d4&scoped=true&"
import script from "./MallItem.vue?vue&type=script&lang=js&"
export * from "./MallItem.vue?vue&type=script&lang=js&"
import style0 from "./MallItem.vue?vue&type=style&index=0&id=d87052d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87052d4",
  null
  
)

export default component.exports